import React, { FC, Fragment } from "react";
import style from "./GlobalLoadingPage.module.scss";
import { useAppSelector } from "../../store";
import LeopartLoader from "../LeopartLoader/LeopartLoader";

interface IGlobalLoadingPage {}

const GlobalLoadingPage: FC<IGlobalLoadingPage> = () => {
  const isLoading = useAppSelector((st) => st.coachMe.loading);

  if (!isLoading) return <Fragment />;
  return (
    <div className={style.container}>
      <LeopartLoader size="lg" />
    </div>
  );
};

export default GlobalLoadingPage;
